import React from "react";
import "./LoadingScreen.css";

export default function LoadingScreen() {
  return (
    <div className="loader-wrapper">
      <div className="loader">
        <div></div>
        <div></div>
        <div></div>
        <div></div>

      </div>
      <p className="loader-text">Loading...</p>
      
    </div>
  );
}
